import { render } from "./relatedArticles.vue?vue&type=template&id=d93caaea"
import script from "./relatedArticles.vue?vue&type=script&lang=js"
export * from "./relatedArticles.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__